
































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Header from "@/components/header.vue";
import LeftNav from "../components/left-nav.vue";
import { getCurrentTime } from "@/utils/base";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import Empty from "@/components/empty.vue";
import {
  UploadFile,
  GetBingliDetail,
  EditZhenci,
  GetZhenciDetail,
  DelZhenci,
  editZhenciTime,
} from "@/request/common";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    Header,
    LeftNav,
    LeaveConfirm,
    Empty,
  },
})
export default class Name extends Vue {
  private id: any = "";
  private ifEdit: any = false;
  private list: any = [];
  private zhenciOptions: any = [
    {
      名称: "初诊",
      value: 0,
    },
    {
      名称: "二诊",
      value: 1,
    },
    {
      名称: "三诊",
      value: 2,
    },
    {
      名称: "四诊",
      value: 3,
    },
    {
      名称: "五诊",
      value: 4,
    },
    {
      名称: "六诊",
      value: 5,
    },
    {
      名称: "七诊",
      value: 6,
    },
    {
      名称: "八诊",
      value: 7,
    },
    {
      名称: "九诊",
      value: 8,
    },
    {
      名称: "十诊",
      value: 9,
    },
  ];
  private cZhenci: any = {};
  private detail: any = {};
  private ifShowZhenci: any = false;
  private addZhenciData: any = {};
  private zhenciType: any = "";
  private editCell: any = {};
  private ifShowTime: any = false;
  private time: any = "";
  private ifShowSaveConfirm: any = false;
  private noSaveText: any = "不保存，切换";
  private saveConfirmType: any = "";
  private editZhenciTimeData: any = {};
  private target: any = {}; // 诊次切换时要切换的诊次数据，或者量表切换时的量表数据
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private get user() {
    return this.$store.state.user;
  }
  private editTimeSure() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      menzhen_id: this.editZhenciTimeData.menzhen_id,
      就诊时间: this.time,
    };
    editZhenciTime(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.getList().then(() => {
          this.ifShowTime = false;
        });
      })
      .catch(() => {
        loading.close();
      });
    // 修改诊次时间
    this.ifShowTime = false;
  }
  private preview(url: any) {
    window.open(url);
  }
  private upload(file: any, key: any) {
    const fileObj = file.file;
    // FormData 对象
    const form = new FormData();
    // 文件对象
    form.append("type", "file");
    form.append("file", fileObj);
    UploadFile(this, form).then((res: any) => {
      this.detail[key] = res.full_file_url;
      this.$forceUpdate();
    });
  }
  private changeZhenci(item: any) {
    // 拦截点击当前诊次的行为
    if (item.menzhen_id == this.cZhenci.menzhen_id) {
      return;
    }
    if (this.ifEdit) {
      this.saveConfirmType = "诊次";
      this.noSaveText = "不保存，切换";
      this.ifShowSaveConfirm = true;
      this.target = item;
    } else {
      this.cZhenci = item;
      this.getDetail();
    }
  }
  private changeSave() {
    this.ifShowSaveConfirm = false;
    if (this.saveConfirmType === "诊次") {
      this.save().then(() => {
        this.cZhenci = JSON.parse(JSON.stringify(this.target));
        this.ifEdit = false;
        this.target = {};
      });
    } else if (this.saveConfirmType === "离开") {
      this.save().then(() => {
        this.$router.back();
      });
    }
  }
  private changeConfirmed() {
    this.ifShowSaveConfirm = false;
    if (this.saveConfirmType === "诊次") {
      this.cZhenci = JSON.parse(JSON.stringify(this.target));
      this.target = {};
      this.ifEdit = false;
      this.getList().then(() => {
        this.getDetail();
      });
    } else if (this.saveConfirmType === "离开") {
      this.ifEdit = false;
      this.$router.back();
    }
  }
  private handleCommand(e: any) {
    if (e.type == "edit") {
      this.addZhenci(e.command);
    } else if (e.type == "time") {
      this.time = e.command["就诊时间"];
      this.editZhenciTimeData = e.command;
      this.ifShowTime = true;
    } else if (e.type == "del") {
      this.$confirm("您确定要删除该数据么？", "删除", {
        customClass: "commonConfirm",
        confirmButtonClass: "iconfont icon-anniu4 confirmSure",
        cancelButtonClass: "iconfont icon-anniu3 confirmCancel",
      })
        .then(() => {
          if (!e.command.menzhen_id || e.command.menzhen_id == "add") {
            this.getList().then(() => {
              if (this.list.length > 0) {
                this.cZhenci = this.list[0];
                this.getDetail();
              } else {
                this.cZhenci = {};
                this.detail = {};
              }
            });
          } else {
            const loading = this.$loading({
              lock: true,
              text: "加载中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            const params: any = {
              data: {
                menzhen_id: e.command.menzhen_id,
              },
            };
            DelZhenci(this, params, loading)
              .then(() => {
                loading.close();
                this.$message.success("删除成功");
                // 删除之后默认选中第一个
                this.getList().then(() => {
                  if (this.list.length > 0) {
                    this.cZhenci = this.list[0];
                    this.getDetail();
                  } else {
                    this.cZhenci = {};
                    this.detail = {};
                  }
                });
              })
              .catch(() => {
                loading.close();
              });
          }
        })
        .catch((e) => {
          console.log("取消了");
        });
    }
  }
  private addOneZhenci(d: any) {
    const obj = {
      id: new Date().getTime(),
      // 创建时间: getCurrentTime("yyyy-MM-dd HH:mm:ss"),
      名称: d["名称"],
      menzhen_id: "add",
    };
    this.list.push(obj);
    this.cZhenci = obj;
    this.detail = {
      medcase_id: this.id,
      medcase_index: d.value,
    };
    this.ifEdit = true;
  }
  private addZhenciSure() {
    if (!this.addZhenciData["名称"]) {
      this.$message.warning("请选择需要添加的诊次");
      return;
    }
    // 判断诊次不能重复
    let repeat: any = false;
    this.list.forEach((ele: any) => {
      if (
        this.zhenciType == "添加" &&
        ele["名称"] == this.addZhenciData["名称"]
      ) {
        repeat = true;
      }
      if (
        this.zhenciType == "修改" &&
        ele["名称"] == this.addZhenciData["名称"] &&
        ele.menzhen_id != this.addZhenciData.menzhen_id
      ) {
        repeat = true;
      }
    });
    if (repeat) {
      this.$message.warning("当前诊次已存在");
      return;
    }
    if (this.zhenciType == "添加") {
      this.addOneZhenci(this.addZhenciData);
      this.ifShowZhenci = false;
    } else {
      // 编辑诊次
      const params: any = {
        params: {
          menzhen_id: this.editCell.menzhen_id,
        },
      };
      GetZhenciDetail(this, params).then((zhenci: any) => {
        const loading = this.$loading({
          lock: true,
          text: "加载中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        zhenci.medcase_index = this.addZhenciData.value;
        EditZhenci(this, zhenci, loading)
          .then((res: any) => {
            loading.close();
            this.$message.success("编辑成功");
            this.ifEdit = false;
            this.ifShowZhenci = false;
            this.getList().then(() => {
              // 更新当前选中的诊次详情
              this.list.forEach((ele: any) => {
                if (ele["名称"] == this.cZhenci["名称"]) {
                  this.cZhenci = ele;
                  this.getDetail();
                }
              });
            });
          })
          .catch(() => {
            loading.close();
          });
      });
    }
  }
  private addZhenci(item?: any) {
    if (this.ifEdit) {
      this.$message.warning("请先保存当前诊次信息！");
      return;
    }
    if (item) {
      this.editCell = JSON.parse(JSON.stringify(item));
      this.addZhenciData = JSON.parse(JSON.stringify(item));
      this.zhenciType = "修改";
      // 置入medcase_index
      this.zhenciOptions.forEach((ele: any) => {
        if (ele["名称"] == this.addZhenciData["名称"]) {
          this.addZhenciData.value = ele.value;
        }
      });
    } else {
      this.zhenciType = "添加";
      this.addZhenciData = {};
    }
    this.ifShowZhenci = true;
  }
  private getDetail() {
    if (!this.cZhenci.menzhen_id || this.list.length == 0) {
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      params: {
        menzhen_id: this.cZhenci.menzhen_id,
      },
    };
    GetZhenciDetail(this, params, loading)
      .then((res: any) => {
        loading.close();
        this.detail = res;
      })
      .catch(() => {
        loading.close();
      });
  }
  private save() {
    return new Promise((resolve, reject) => {
      if (!this.detail["主诉"]) {
        this.$message.warning("请输入主诉");
        return;
      }
      if (!this.detail["现病史"]) {
        this.$message.warning("请输入现病史");
        return;
      }
      if (!this.detail["中药饮片信息"]) {
        this.$message.warning("请输入中药饮片信息");
        return;
      }
      if (!this.detail["舌图"]) {
        this.$message.warning("请上传舌图");
        return;
      }
      if (!this.detail["脉诊图"]) {
        this.$message.warning("请上传脉诊图");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      EditZhenci(this, this.detail, loading)
        .then((res: any) => {
          loading.close();
          this.$message.success("保存成功");
          this.ifEdit = false;
          this.getList().then(() => {
            // 更新当前选中的诊次详情
            this.list.forEach((ele: any) => {
              if (ele["名称"] == this.cZhenci["名称"]) {
                this.cZhenci = ele;
                this.getDetail();
              }
            });
          });
          resolve(true);
        })
        .catch(() => {
          loading.close();
        });
    });
  }
  private getList() {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          medcase_id: this.id,
        },
      };
      GetBingliDetail(this, params, loading).then((res: any) => {
        this.list = res["诊次"];
        resolve(true);
      });
    });
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.ifEdit) {
      this.saveConfirmType = "离开";
      this.noSaveText = "不保存，离开";
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    if (this.$route.query.type == "添加") {
      const d = JSON.parse(this.$route.query.data as any);
      this.detail.medcase_id = this.$route.query.id;
      this.detail.medcase_index = d.value;
      this.getList().then(() => {
        // 拦截刷新时，如果路由传参的诊次已存在，就不能重新增加一次
        let ifExit: any = false;
        this.list.forEach((ele: any) => {
          if (ele["名称"] == d["名称"]) {
            ifExit = true;
          }
        });
        if (!ifExit) {
          this.addOneZhenci(d);
          this.ifEdit = true;
        } else {
          this.cZhenci = this.list[0];
          this.getDetail();
        }
      });
    } else if (this.$route.query.type == "修改") {
      const d = JSON.parse(this.$route.query.data as any);
      this.getList().then(() => {
        this.cZhenci = d;
        this.getDetail();
      });
    }
  }
}
